import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const Pagination = ({ currentPage, totalPages, onPageChange, loading }) => {
  if (totalPages <= 1) return null;

  // Generate page numbers
  const pages = [];
  const maxVisible = 5;
  
  let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);

  if (end - start + 1 < maxVisible) {
    start = Math.max(1, end - maxVisible + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div className="flex items-center justify-center gap-2 py-8">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || loading}
        className="p-2 rounded-lg bg-dark-card border border-white/10 text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-all"
      >
        <FiChevronLeft size={20} />
      </button>

      {start > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            disabled={loading}
            className={`px-4 py-2 rounded-lg font-bold transition-all ${
              currentPage === 1
                ? 'bg-primary-light text-white shadow-lg shadow-primary-light/20'
                : 'bg-dark-card border border-white/10 text-gray-400 hover:text-white'
            }`}
          >
            1
          </button>
          {start > 2 && <span className="text-gray-600">...</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          disabled={loading}
          className={`px-4 py-2 rounded-lg font-bold transition-all ${
            currentPage === page
              ? 'bg-primary-light text-white shadow-lg shadow-primary-light/20'
              : 'bg-dark-card border border-white/10 text-gray-400 hover:text-white'
          }`}
        >
          {page}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="text-gray-600">...</span>}
          <button
            onClick={() => onPageChange(totalPages)}
            disabled={loading}
            className={`px-4 py-2 rounded-lg font-bold transition-all ${
              currentPage === totalPages
                ? 'bg-primary-light text-white shadow-lg shadow-primary-light/20'
                : 'bg-dark-card border border-white/10 text-gray-400 hover:text-white'
            }`}
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || loading}
        className="p-2 rounded-lg bg-dark-card border border-white/10 text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-all"
      >
        <FiChevronRight size={20} />
      </button>
    </div>
  );
};

export default Pagination;
